import React from "react";
import config from "../config.ts";

// The discrete travel-time colour bands, fastest first.
const ColourBar = () => (
  <div className="flex h-2 w-36 overflow-hidden rounded-full">
    {config.colours.map((colour) => (
      <div key={colour} className="h-full grow" style={{ backgroundColor: colour }} />
    ))}
  </div>
);

export default ColourBar;
